import React from 'react';
import { Link } from 'react-router-dom';
import heroImage from '../../assets/images/wind-farm.png';
import Reveal from '../Reveal/Reveal';
import { IconCheckCircle } from '../Icons/Icons';
import '../../assets/css/hero.css';

const CREDENTIALS = ['Ofgem & GGCS Compliance', 'ISCC Certification', 'Carbon & SECR Reporting'];

function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero-backdrop" aria-hidden="true">
        <span className="hero-glow hero-glow-teal" />
        <span className="hero-glow hero-glow-green" />
        <span className="hero-grid" />
      </div>

      <div className="container hero-inner">
        <div className="hero-content">
          <Reveal direction="up">
            <p className="hero-kicker">
              <span className="hero-kicker-dot" />
              Sustainability &amp; Compliance Consultancy
            </p>
          </Reveal>

          <Reveal direction="up" delay={90}>
            <h1 className="hero-title">
              For <span className="hero-title-accent">Renewable Energy</span> Businesses
            </h1>
          </Reveal>

          <Reveal direction="up" delay={170}>
            <p className="hero-description">
              We help businesses in the renewable fuels, bioenergy and low-carbon energy sectors
              understand and comply with sustainability requirements, certification schemes and
              regulatory obligations, so products and feedstocks can be traded with confidence in
              UK and international markets.
            </p>
          </Reveal>

          <Reveal direction="up" delay={250}>
            <div className="hero-actions">
              <Link to="/services" className="btn btn-primary">
                Our Services
              </Link>
              <Link to="/contact" className="btn btn-secondary">
                Contact Us
              </Link>
            </div>
          </Reveal>

          <Reveal direction="up" delay={320}>
            <div className="hero-credentials">
              <span className="hero-credentials-label">Areas of Expertise</span>
              <ul className="hero-credentials-list">
                {CREDENTIALS.map((item) => (
                  <li className="hero-credential" key={item}>
                    <IconCheckCircle width={15} height={15} />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>

        <Reveal direction="right" delay={140}>
          <figure className="hero-visual">
            <span className="hero-visual-glow" aria-hidden="true" />
            <div className="hero-visual-frame">
              <img
                src={heroImage}
                alt="Wind turbines across green UK farmland under a blue sky"
              />
              <div className="hero-visual-overlay" />

              <div className="hero-visual-badge">
                <span className="hero-visual-badge-icon">
                  <IconCheckCircle width={20} height={20} />
                </span>
                <span className="hero-visual-badge-text">
                  <strong>Fully Compliant</strong>
                  Ofgem &amp; ISCC Certified
                </span>
              </div>
            </div>
            <figcaption className="hero-visual-caption">
              Renewable Fuels · Bioenergy · Low-Carbon Energy
            </figcaption>
          </figure>
        </Reveal>
      </div>
    </section>
  );
}

export default Hero;
